import localStorageKey from "../enumerations/localStorageKey";

export const getLang = (): string | undefined => {
  const localLang = window.localStorage.getItem(localStorageKey.DEFAULT_LANG);
  switch (localLang) {
    case "jp":
      return "ja";
    default:
      return localLang || undefined;
  }
};
